import { EllipsizedSpan, LocalizedTextTag } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';

interface Props {
    label: string;
    tag: Mews.TextKey;
}

const SendEmailDialogCheckboxLabel = ({ label, tag, ...props }: Props) => (
    <Stack spacing="100" itemAlignment="center">
        <EllipsizedSpan {...props}>{label}</EllipsizedSpan>
        <LocalizedTextTag textKey={tag} variant="denim" />
    </Stack>
);

export default SendEmailDialogCheckboxLabel;
